import { useMemo } from 'react'
import { ThemeProvider, useTheme } from 'styled-components'
import { formatDimensions } from '../hooks/useDimensions/formatDimensions'
import { breakPoints } from './breakPoints'

const zeroInsets = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
}

export const OverrideScreenSize = ({ breakPoint, width, height, children }) => {
  const theme = useTheme()

  const resizedTheme = useMemo(() => {
    const window = {
      width: (breakPoint ? breakPoints[breakPoint] : width) || theme.width,
      height: height || theme.height,
    }
    const dimensions = formatDimensions({ window, screen: window }, zeroInsets, true)
    return {
      ...theme,
      dimensions,
      width: dimensions.width,
      height: dimensions.height,
    }
  }, [breakPoint, width, height, theme])

  return <ThemeProvider theme={resizedTheme}>{children}</ThemeProvider>
}
